import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=353bafbe&scoped=true&"
import script from "./Field.vue?vue&type=script&lang=js&"
export * from "./Field.vue?vue&type=script&lang=js&"
import style0 from "./Field.vue?vue&type=style&index=0&id=353bafbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353bafbe",
  null
  
)

export default component.exports